import React, { createContext, useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';
import StackedToasts from '../StackedToasts';
import { nanoid } from 'nanoid';
import createPortalSSR from '../../helpers/createPortalSSR';
import usePortalContainer from '../../hooks/usePortalContainer';

export const ToastContext = createContext({});

// The app context provider component
const ToastContextProvider = ({ children }) => {
    // defaultToastContext is returned by the server on the initial render
    const [messages, setMessages] = useState([]);
    const sendMessage = useCallback((text = '', bg = 'light') => {
        const isoDate = DateTime.now().toISO();
        setMessages((prevMessages) => [...prevMessages, {
            id: nanoid(),
            text,
            isoTime: isoDate,
            bg,
        }]);
    }, []);
    const contextValue = useMemo(() => ({
        sendMessage,
    }), [sendMessage]);
    const container = usePortalContainer('notif-toast');
    return (<ToastContext.Provider
        value={contextValue}>
        {createPortalSSR(
            <StackedToasts
                setMessages={setMessages}
                messages={messages}></StackedToasts>,
            container,
        )}
        {children}
    </ToastContext.Provider>);
};

ToastContextProvider.propTypes = {
    children: PropTypes.node,
};

export default ToastContextProvider;